import { apiClient } from '@/client'

const state = {
  plans: [],
  userPlan: null
}

const getters = {
  plans: state => state.plans,
  userPlan: state => state.userPlan
}

const mutations = {
  SET_PLANS: (state, payload) => {
    state.plans = payload
  },
  SET_USER_PLAN: (state, payload) => {
    state.userPlan = payload
  }
}

const actions = {
  fetchPlans: ({ commit }) => {
    return new Promise((resolve, reject) => {
      apiClient
        .getAllPlans()
        .then(payload => {
          commit('SET_PLANS', payload)
        })
        .catch(reject)
    })
  },
  getUserPlan: ({ commit }) => {
    return new Promise((resolve, reject) => {
      apiClient
        .getUserPlan()
        .then(payload => {
          commit('SET_USER_PLAN', payload)
        })
        .catch(reject)
    })
  },
  setPlan: ({ dispatch, commit }, planId) => {
    return new Promise((resolve, reject) => {
      apiClient
        .setUserPlan(planId)
        .then(payload => {
          commit('SET_USER_PLAN', payload)
        })
        .catch(reject)
    })
  }
}

export default { state, getters, mutations, actions }
